import { useTranslation } from 'react-i18next';
import {
  isInteractionConfirmShowed,
  addInteractionConfirmShowedPatient,
} from 'infrastructure/functions/interactionConfirmShowed';
import { ModuleType } from 'infrastructure/enums';

import useAlert from './use-alert';

import type { IAlertOptions } from './use-alert';

interface ShowOptions extends Partial<IAlertOptions> {
  showSecondAlert?: boolean;
  ignoreIsShowed?: boolean;
  module?: ModuleType.RPM | ModuleType.CCM;
  interactionType?: 'call' | 'note';
}

interface Props {
  patientGuid: string;
}

const useMonthlyInteractionAlert = ({ patientGuid }: Props) => {
  const { Alert: MonthlyInteractionAlert, showAlert } = useAlert();

  const { t } = useTranslation();

  const showMonthlyInteractionAlert = async (
    options: ShowOptions = {},
  ): Promise<boolean> => {
    const module = options.module || ModuleType.RPM;
    if (!options.ignoreIsShowed) {
      if (isInteractionConfirmShowed({ patientGuid, module })) return false;
      addInteractionConfirmShowedPatient({ patientGuid, module });
    }

    let messageTitle = t('confirm.clinicalNoteMonthlyInteraction');
    if (options.interactionType === 'call') {
      messageTitle = t('confirm.callEndedMonthlyInteraction');
    }

    let alertAnswer = await showAlert({
      title: t('labels.monthlyInteraction'),
      messageTitle,
      successBtnLabel: t('controls.yes'),
      rejectBtnLabel: t('controls.no'),
      ...options,
    });

    if (options.showSecondAlert && alertAnswer) {
      alertAnswer = await showAlert({
        title: t('labels.monthlyInteraction'),
        messageTitle: t('confirm.clinicalNoteMonthlyInteraction2'),
        successBtnLabel: t('controls.yes'),
        rejectBtnLabel: t('controls.no'),
        ...options,
      });
    }

    return alertAnswer;
  };

  return {
    showMonthlyInteractionAlert,
    MonthlyInteractionAlert,
  };
};

export default useMonthlyInteractionAlert;
